import { datetime } from '@bringg/types';

export enum ENVIRONMENT {
	DEVELOPMENT = 'development',
	PRODUCTION = 'production',
	TEST = 'test'
}

export interface WayPointLocation {
	location: google.maps.LatLng;
	wayPointPosition: number;
	id: number;
}

export interface ActionsConfiguration {
	id: number;
	title: string;
	actionData: any;
}

export enum ActionsConfigurationLevel {
	USER = 'all_orders',
	ORDER = 'order',
	INVENTORY = 'inventory'
}

export const DefaultDateFormat = 'DD/MM/YYYY';

export type RouteLocation = {
	lat: number;
	lng: number;
	happened_at: datetime;
};

export enum ScreenType {
	MOBILE = 'mobile',
	DESKTOP = 'desktop'
}
